/**
 * WalletEventTypes - Event constants for wallet-related events.
 *
 * Used with the global EventBus for cross-component wallet communication.
 */

export const WalletEvents = {
  CONNECTED: 'wallet:connected',
  DISCONNECTED: 'wallet:disconnected',
  ACCOUNT_CHANGED: 'wallet:account_changed',
  CHAIN_CHANGED: 'wallet:chain_changed',
  BALANCE_UPDATED: 'wallet:balance_updated',
  TRANSACTION_SENT: 'wallet:transaction_sent',
  TRANSACTION_CONFIRMED: 'wallet:transaction_confirmed',
  TRANSACTION_FAILED: 'wallet:transaction_failed',
} as const;

export type WalletEventType = (typeof WalletEvents)[keyof typeof WalletEvents];
